import * as env from "@devforce/trailhead-client-env";
import { fetchJSON, postJSON } from "@devforce/trailhead-client-fetch";
import { Logger } from "@devforce/trailhead-client-logger";
import { PollingRequest } from "./PollingRequest";
export const PACKAGE_NAME = "@devforce/trailhead-client-api";
export const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
const CSRF_WARNING = "A CSRF token required for this request. Set it using configure().";
export { PollingRequest };
export const CSRF_HEADER = "X-CSRF-Token";
export class APIClient {
    constructor(init = {}) {
        this.baseUrl = getDefaultBaseUrl();
        this.csrfToken = getDefaultCsrf();
        this.configure(init);
    }
    get headers() {
        if (!this.csrfToken) {
            logger.warn(CSRF_WARNING);
        }
        return {
            [CSRF_HEADER]: `${this.csrfToken}`,
        };
    }
    configure(init) {
        Object.assign(this, init);
    }
    delete(path, body) {
        return postJSON(this.url(path), body, {
            credentials: "same-origin",
            method: "DELETE",
            headers: this.headers,
        });
    }
    get(path) {
        return fetchJSON(this.url(path), {
            credentials: "same-origin",
        });
    }
    import(path) {
        return import(this.url(path));
    }
    patch(path, body) {
        return postJSON(this.url(path), body, {
            credentials: "same-origin",
            method: "PATCH",
            headers: this.headers,
        });
    }
    async poll(args) {
        return new PollingRequest(args);
    }
    post(path, body) {
        return postJSON(this.url(path), body, {
            credentials: "same-origin",
            headers: this.headers,
        });
    }
    url(path) {
        return [this.baseUrl, path].map((s) => s.replace(/^\/|\/$/g, "")).join("/");
    }
}
function getDefaultBaseUrl() {
    return env.get("API_HOST");
}
function getDefaultCsrf() {
    try {
        return document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content");
    }
    catch (error) {
        return null;
    }
}
export function getClient() {
    return state.client;
}
let state = {
    client: new APIClient(),
};
export function initializeState(currentState, existingState) {
    return existingState !== null && existingState !== void 0 ? existingState : currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
